(() => {
  let cancelled = false;
  let running = false;
  function cancel() { cancelled = true; }
  ['wheel','touchstart','pointerdown'].forEach(event => window.addEventListener(event, cancel, {passive:true}));
  window.addEventListener('keydown', event => { if (['ArrowDown','ArrowUp','PageDown','PageUp','Home','End',' '].includes(event.key)) cancel(); });
  async function go() {
    if (location.hash !== '#khlgan-products' || running) return;
    running = true;
    cancelled = false;
    if (document.readyState !== 'complete') await new Promise(resolve => window.addEventListener('load',resolve,{once:true}));
    if (document.fonts) await document.fonts.ready;
    await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    const target = document.getElementById('khlgan-products');
    if (target && !cancelled) {
      const top = target.getBoundingClientRect().top + window.scrollY - 24;
      window.scrollTo({top:Math.max(0,top),behavior:'instant'});
    }
    running = false;
  }
  window.addEventListener('pageshow',go);
  window.addEventListener('hashchange',go);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href,location.href);
    if (url.origin === location.origin && url.pathname === location.pathname && url.hash === '#khlgan-products') {
      cancelled = false;
      setTimeout(go,0);
    }
  });
  go();
})();